/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportAbuse} from '../api'

export const useMutationReportAbuse = createReactQueryMutationHook('reportAbuse', reportAbuse)
